<div class="home-address">
  <input nbInput fieldSize="small" [(ngModel)]="address.street" [placeholder]="'tracking.trips.street' | translate">
  <input nbInput fieldSize="small" [(ngModel)]="address.number" [placeholder]="'tracking.trips.number' | translate">
  <input nbInput fieldSize="small" [(ngModel)]="address.postcode" [placeholder]="'tracking.trips.postcode' | translate">
  <input nbInput fieldSize="small" [(ngModel)]="address.town" [placeholder]="'tracking.trips.town' | translate">
  <button nbButton size="small" status="primary" [disabled]="busy" (click)="save()">{{ 'save' | translate }}</button>
</div>
